export class MGiftVoucherPriceCategory {
  indexNo: number;
  price: number;
  createDate: Date;
  color: string;
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-price-category/model/m-gift-voucher-price-category.ts